<template>
  <spinner />
</template>

<script>
import { mapGetters } from 'vuex'
import Spinner from '@/components/Spinner'
import { FETCH_PROFILE } from '@/store/actions.type'
export default {
  name: 'JumpsellerIntegrationPage',
  components: {
    Spinner
  },
  data() {
    return { integrationDone: false, platformSlug: 'jumpseller' }
  },
  props: {
    type: {
      type: String,
      default: 'ongoing'
    }
  },
  computed: {
    ...mapGetters([ 'user' ])
  },
  beforeMount() {
    this.$store.dispatch(FETCH_PROFILE)
  },
  async mounted() {
    await this.setJumpSellerIntegration()
  },
  watch: {
    user(val) {
      if (!this.integrationDone) {
        if (this.$route.query.code) this.setJumpSellerIntegration()
        else this.$router.push({ name: 'new' })
      }
    }
  },
  methods: {
    async generateApplication() {
      const {data: response} = await this.$http.get(this.$appConfig.api.baseUrl + 'platforms')
      const platforms = response.data
      const thePlatform = platforms.find(x => x.slug === this.platformSlug)
      const application = this.getPreviousApplication(thePlatform)
      if (application) return application
      const payload = {
        name: this.user.company.name + ' ' + thePlatform.name,
        company_id: this.user.company_id,
        platform_id: thePlatform.id,
        active: true
      }
      const {data} = await this.$http.post(this.$appConfig.api.baseUrl + 'applications', payload)
      return data
    },
    getPreviousApplication(thePlatform) {
      for (const app of this.$store.getters.profile.company.applications) {
        if (!app.webhook_url) continue
        const urlObj = new URL(app.webhook_url)
        const params = new URLSearchParams(urlObj.search)
        if (app.platform.id === thePlatform.id && params.get('userId') === String(this.user.id)) {
          return app
        }
      }
      return null
    },
    async setJumpSellerIntegration() {
      if (!this.isValidCompany()) return false
      const credentials = await this.generateApplication()
      if (this.integrationDone) return true
      this.integrationDone = true
      const body = {
        'companyId': String(this.user.company_id),
        'userId': this.user.id,
        'appId': credentials.id,
        'appKey': credentials.key,
        'code': String(this.$route.query.code),
        'metadata': { 'shippingTypesEnabled': ['regular', 'next_day'] }
      }
      const path = this.$appConfig.integrations.ecommerce.baseUrl + this.platformSlug + '/authenticate'
      const headers = { 'x-api-key': this.$appConfig.integrations.ecommerce.header }
      try {
        await this.$http.post(path, body, {headers})
        this.$store.dispatch(FETCH_PROFILE).then(response => {
          let payload = { profile: this.user }
          this.$store.commit('setProfile', payload)
          this.$router.push({ name: 'company-integrations' })
        })
      } catch (error) {
        return this.throwErrorIntegration(error)
      }
    },
    throwErrorIntegration(error) {
      if (error.status === 422) {
        const message = this.$gettext('Authorization code doesn\'t exist or is invalid for the client.<br><br>Please try again now you are identified here.')
        const obj = {title: 'ERROR', message: message, type: 'error'}
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
      }

      this.$router.push({ name: 'search' })
    },
    isValidCompany() {
      const isValid = this.user && this.user.company_id
      if (isValid) return true
      let obj = {
        title: 'ERROR',
        message: this.$gettextInterpolate(this.$gettext('Your user doesn\'t have a company defined which is required to be able to enjoy the benefits of the e-commerce integrations.<br><br>Please write to <a href="mailto:%{helpEmail}">%{helpEmail}</a> to get this solved.'), {helpEmail: this.helpEmail}),
        type: 'error'
      }
      this.$root.$children[0].$refs.simplert.openSimplert(obj)
      this.$router.push({ name: 'search' })
      return false
    }
  }
}
</script>
